import {
  ProductDto,
  ProductsResponse,
  Profile,
  Provider,
} from '@features/products/interfaces/productInterface';
import { PageListTemplate } from '@templates';
import { ColumnType } from 'antd/es/table';

import type { PageListColumnVisibilityConfig } from 'src/app/framework/templates/PageList/PageList.interface';
import type { PageListColumnOrderState } from 'src/app/framework/templates/PageList/usePageListColumnOrder';
import type { PageListColumnVisibilityState } from 'src/app/framework/templates/PageList/usePageListColumnVisibility';

import { FilterProducts } from './FilterProducts';

type ProductTableProps = {
  productsData: ProductsResponse;
  initialFilterData?: Record<string, any>;
  currentFilter: Record<string, any>;
  pageSize: number;
  handleChangeFilter: (filter: Record<string, any>) => void;
  handleChangePagination: (
    take: number,
    skip: number,
    pagination: number
  ) => void;
  columns: ColumnType<ProductDto>[];
  columnOrderState?: PageListColumnOrderState<ProductDto>;
  columnVisibilityState?: PageListColumnVisibilityState<ProductDto>;
  profilesData: Profile[];
  providersData: Provider[];
};

export const PRODUCT_COLUMN_VISIBILITY_CONFIG: PageListColumnVisibilityConfig =
  {
    enabled: true,
    persist: true,
    storageKey: 'products-list-column-visibility',
    alwaysVisibleColumnKeys: ['action'],
    initiallyHiddenColumnKeys: ['providerId', 'subscriptionType'],
  };
export const PRODUCT_DRAG_COLUMN_STORAGE_KEY = 'products-list-drag-column';
export const PRODUCT_FIXED_COLUMN_KEYS = ['action'];

export const ProductTable: React.FC<ProductTableProps> = ({
  productsData,
  initialFilterData,
  currentFilter,
  pageSize,
  handleChangeFilter,
  handleChangePagination,
  columns,
  columnOrderState,
  columnVisibilityState,
  profilesData,
  providersData,
}) => {
  return (
    <PageListTemplate
      filterComponent={
        <FilterProducts
          initialFilterData={initialFilterData}
          onChangeFilter={handleChangeFilter}
          profiles={profilesData.map(profile => ({
            label: `${profile.id} - ${profile.name}`,
            value: String(profile.id),
          }))}
          providers={providersData.map(provider => ({
            label: `${provider.name}`,
            value: String(provider.id),
          }))}
        />
      }
      stickyHeader
      columns={columns}
      data={productsData}
      pageSize={pageSize}
      currentPage={currentFilter.page || 1}
      onChange={handleChangePagination}
      columnVisibilityConfig={PRODUCT_COLUMN_VISIBILITY_CONFIG}
      columnOrderState={columnOrderState}
      columnVisibilityState={columnVisibilityState}
      enableDragColumn
      dragColumnStorageKey={PRODUCT_DRAG_COLUMN_STORAGE_KEY}
      fixedColumnKeys={PRODUCT_FIXED_COLUMN_KEYS}
      onChangePagination={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
    />
  );
};
